import { Component, OnInit } from '@angular/core';
import {
    IReservation,
    Reservation,
    IReservationRow
} from '../../model/reservation';

import {
    IMonthChangeEvent,
    IEditEvent
} from '../../calendar/calendar.component';
import {
    IInvoice,
    IOrderRow,
    Payment
} from '../../model/payment';
import {
    DateString,
    IError
} from '../../model/types';
import { Message } from 'primeng/primeng';
import { LocalStorageService } from 'angular-2-local-storage';
import { User } from '../../model/user';
import { ICustomer } from '../../model/customer';

const moment = require('../../../../../node_modules/moment/moment.js');
const _ = require('../../../../../node_modules/lodash/index');

@Component({
    selector: 'reservation-component',
    template: require('./reservation.component.html'),
    styles: [require('./reservation.component.css')]
})

export class ReservationComponent implements OnInit {

    public reservations: IReservationRow[] = [];
    public reservationsIndex : {[id: string]: IReservationRow[]};
    public reservationsLoaded : boolean = false;
    public editingReservation : IReservation = null;

    public editReservations : IReservation[];
    public displayEdit = false;
    public vatPcs = [10, 24];
    public newVatPc = 24;

    public reservationTypes = [
        {type: 'TYPE_HOURS', label: 'Tunteja'},
        {type: 'TYPE_DAY', label: 'Päivä'},
        {type: 'TYPE_WEEKEND', label: 'Viikonloppu'}
    ];

    public reservationTimes = [
        {type: 'TIME_MORNING', label: 'Aamu'},
        {type: 'TIME_EVENING', label: 'Ilta'}
    ];

    public newRow = {
        name: '',
        price: ''
    };

    public editingInvoice : IInvoice;
    public newInvoice : IInvoice;
    public errors : IError[];
    public editDate : DateString;
    public alerts: Message[] = [];
    public invoiceType : string;
    public invoiceTypes = [
        {
            type: 'TYPE_PREPAYMENT',
            label: 'Ennakkomaksu'
        },
        {
            type: 'TYPE_INTERIM_PAYMENT',
            label: 'Välimaksu'
        },
        {
            type: 'TYPE_FINAL_PAYMENT',
            label: 'Loppumaksu'
        }
    ];

    public statuses = [
        {
            status: 0,
            label: 'Uusi'
        },
        {
            status: 1,
            label: 'Maksettu'
        },
        {
            status: 2,
            label: 'Hylätty'
        },
        {
            status: 3,
            label: 'Palautettu'
        }
    ];

    private start : DateString;
    private stop : DateString;

    constructor (
        private ReservationResource: Reservation,
        private PaymentResource: Payment,
        private localStorageService: LocalStorageService,
        private UserResource : User
    ) {}

    public ngOnInit(): any {
        document.getElementsByClassName("frontPageTop")[0].innerHTML = '';
        document.getElementsByClassName("frontPageBottom")[0].innerHTML = '';
    }

    public onMonthChanged(event : IMonthChangeEvent) {
        this.start = event.start;
        this.stop = event.stop;
        this.loadMonth();
    }

    public onEdit(event : IEditEvent) {
        this.displayEdit = false;
        if (event.reservations.length) {
            this.ReservationResource.byIds({ids: event.reservations})
                .$observable
                .subscribe((reservations : IReservation[]) => {
                    this.editReservations = reservations;
                    this.displayEdit      = true;
                });
        } else {
            this.editReservations = [];
            this.displayEdit      = true;
        }
        this.editDate = event.date;
    }

    public editReservation(reservation : IReservation) {
        reservation.startDate = moment(reservation.startDate).toDate();
        this.editingReservation = reservation;
    }

    public newReservation() {
        this.editingReservation = Reservation.newReservation(moment(this.editDate).toDate());
    }

    public removeRow(row : IOrderRow) {
        this.editingReservation.order.rows.splice(this.editingReservation.order.rows.indexOf(row), 1);
    }

    public addRow() {
        if (!this.editingReservation.order) {
            this.editingReservation.order = {id: null, rows: [], invoices: [], total: 0};
        }
        this.editingReservation.order.rows.push({id: null, name: this.newRow.name, price: Number(this.newRow.price)});
        this.newRow = {
            name: '',
            price: ''
        };
    }

    /**
     * also calc newVatPc here
     */
    public calcTotal() {
        this.newVatPc = this.editingReservation.staff ? 10 : 24;
        let total = 0;
        if (!this.editingReservation.order) {
            return total;
        }
        for (let row of this.editingReservation.order.rows) {
            total += Number(row.price);
        }
        return this.editingReservation.order.total = total;
    }

    private fillRequired(customer : ICustomer) {
        if (!customer.firstname) {
            customer.firstname = ' ';
        }
        if (!customer.lastname) {
            customer.lastname = ' ';
        }
        if (!customer.email) {
            customer.email = 'a@a.com';
        }
        if (!customer.address) {
            customer.address = ' ';
        }
        if (!customer.postOffice) {
            customer.postOffice = ' ';
        }
      if (!customer.zipCode) {
        customer.zipCode = ' ';
      }
      if (!customer.phone) {
        customer.phone = ' ';
      }
    }

    public save(reservation : IReservation) {
        let copy = Object.assign({}, reservation);
        copy.startDate = copy.startDate && moment(copy.startDate).format('YYYY-MM-DD');
        this.fillRequired(copy.reserver);

        this.ReservationResource.save(copy)
            .$observable
            .subscribe((savedReservation : IReservation) => {
                savedReservation.startDate = savedReservation.startDate && moment(savedReservation.startDate).toDate();
                _.merge(reservation, savedReservation);
                // console.log(reservation);
                this.errors = null;
                this.alerts = [];
                this.loadMonth();
            }, (response) => {
                let errors = response.json();
                if (errors.errors) {
                    this.errors = errors;
                } else if (errors.message) {
                    this.alerts.push({severity: 'error', summary: 'Virhe tallennuksessa', detail: errors.message});
                }
                // console.log(errors);
            });
    }

    public editInvoice(invoice : IInvoice) {
        this.editingInvoice = invoice;
    }

    public addInvoice() {
        this.editingReservation.order.invoices.push({
            id          : null,
            type        : this.invoiceType,
            amount      : Number(this.editingReservation.order.total),
            firstname   : this.editingReservation.reserver.firstname,
            lastname    : this.editingReservation.reserver.lastname,
            address     : this.editingReservation.reserver.address,
            zipCode     : this.editingReservation.reserver.zipCode,
            postOffice  : this.editingReservation.reserver.postOffice,
            rows        : this.editingReservation.order.rows,
            status      : 0,
            vatPc       : this.newVatPc
        });
    }

    private loadMonth() {
        this.reservationsLoaded = false;
        this.ReservationResource.search({start: this.start, stop: this.stop})
            .$observable
            .subscribe((reservations: IReservationRow[]) => {
                this.reservations = reservations;
                this.reservationsIndex = {};
                this.reservations.map((reservation : IReservationRow) => {
                    if (!this.reservationsIndex[reservation.date]) {
                        this.reservationsIndex[reservation.date] = [];
                    }
                    this.reservationsIndex[reservation.date].push(reservation);
                });
                this.reservationsLoaded = true;
            });
    }

    public logout() {
        this.UserResource.logout()
            .$observable
            .subscribe(() => {
                this.localStorageService.set('user', null);
                document.location.href = '/';
            });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/admin/reservation/reservation.component.ts